export async function isExtensionFuckingCanvas() {
    // 排除 Worker 上下文本身
    if (typeof window === 'undefined') return false;
    if (!(globalThis.Worker)) return true; // 能运行ESM的浏览器没有Worker？必定是被扩展干了！
    const canvas = document.createElement('canvas');
    canvas.width = 1920;
    canvas.height = 1080;
    canvas.style.opacity = 0; canvas.style.position = 'fixed';
    document.body.append(canvas);
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = 'red';
    ctx.fillRect(0, 0, 100, 100);
    await new Promise(r => setTimeout(r, 10));
    if (canvas.toDataURL() !== canvas.toDataURL()) {
        canvas.remove();
        return true;
    }
    // 故意制造报错
    try {
        ctx.getImageData();
    }
    catch (e) {
        canvas.remove();
        const s = e.stack;
        if (s && (!(/chrome-extension/i.test(s)))) return false;
    }
    // this line should not be reached
    canvas.remove();
    return true;
}
